import React from "react";
import { scaleLinear } from "d3-scale";
import Tick from "./Gauge/Tick";
import styled from "styled-components";

const generateRangeIncrements = ({ min, max}) => {
    const out = [];
    const increment = Math.abs(max - min) / 10;
    for (let i = min; i <= max; i += increment) {
        out.push(i);
    }
    return out;
};

const fillRange = ({min, max}) => {
    const out = [];
    for(let i = min; i <= max; i ++){
        out.push(i)
    }
    return out
}

const Wrapper = styled.div`
    width: 300px;
    margin: 0 auto;
    padding: 20px;
`;

const TextContainer = styled.div`
    margin: 0 auto;
    text-align: center;
`;

export default ({ min, max, value, children }) => {
    const percentScale = scaleLinear().domain([min, max]).range([0, 1]);
    const percent = percentScale(value);

    const angleScale = scaleLinear()
        .domain([0, 1])
        .range([-Math.PI / 3, Math.PI / 3])
        .clamp(true);
    const angle = angleScale(percent);

    return (
        <Wrapper>
            <svg viewBox={[-1, -1, 2, 1].join(" ")}>
                <style>.note {"{font: 40px bold;}"}</style>
                {fillRange({ min: -9, max: 9}).map(val => (
                        <line
                            x1="0"
                            y1="0.025"
                            x2="0"
                            y2="0.075"
                            strokeWidth="0.05"
                            stroke="#11aa33"
                            key={'filler_' + val}
                            transform={`translate(0 -1) rotate(` + angleScale(percentScale(val)) * (180 / Math.PI) + ` 0 1)`}
                        />
                    )
                )}
                {generateRangeIncrements({ min, max }).map((val) => (
                    <Tick
                        key={val}
                        emphasized={val === min || val === max || val === 0}
                        rotation={
                            angleScale(percentScale(val)) * (180 / Math.PI)
                        }
                    />
                ))}

                <line
                    x1="0"
                    y1="-1"
                    x2="0"
                    y2="0"
                    strokeWidth="0.015"
                    stroke="#333333"
                    transform={`rotate(${angle * (180 / Math.PI)})`}
                />
                <circle cy={-0.035} r={0.035} fill="#333333" />
            </svg>
            <TextContainer>{children}</TextContainer>
        </Wrapper>
    );
};
